var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNamibia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51475 20.4853C4.01814 20.9887 4.55524 21.4376 5.11863 21.8329L21.8328 5.11866C21.4376 4.55527 20.9887 4.01817 20.4852 3.51478C19.9818 3.01139 19.4448 2.56252 18.8814 2.16727L2.16724 18.8815C2.56244 19.4448 3.01136 19.9819 3.51475 20.4853Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.51469C-0.271105 7.3005 -0.997855 12.9861 1.33291 17.5021L17.5021 1.33298C12.986 -0.997783 7.30043 -0.27094 3.51471 3.51469Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 20.4853C24.271 16.6996 24.9978 11.014 22.6671 6.49789L6.49792 22.6671C11.0139 24.9978 16.6995 24.2711 20.4853 20.4853Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91301 6.78261L8.56836 7.4151L9.28442 8.71738L7.82431 8.4381L7.63925 9.91302L6.62225 8.82819L5.6052 9.91302L5.42023 8.4381L3.96008 8.71733L4.67609 7.41505L3.33148 6.78261L4.67614 6.15008L3.96008 4.84789L5.42019 5.12718L5.60525 3.65216L6.62225 4.73704L7.63929 3.65216L7.82431 5.12718L9.28442 4.84789L8.56845 6.15013L9.91301 6.78261Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamibia);
export default __webpack_public_path__ + "static/media/namibia.3382aa8a318b1afd17b882a2f13fea7a.svg";
export { ForwardRef as ReactComponent };